// DevFilePreview.js — Aperçu léger (syntax highlight seulement petits fichiers)

import React, { memo } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import DevEditorPane, { DevEditorEmpty, DevEditorLoading } from './DevEditorPane';
import './devCockpit.css';

const HIGHLIGHT_MAX = 24_000;

function DevFilePreview({ path, language, content, loading }) {
    if (loading) {
        return (
            <DevEditorPane>
                <DevEditorLoading />
            </DevEditorPane>
        );
    }

    if (!path) {
        return (
            <DevEditorPane>
                <DevEditorEmpty />
            </DevEditorPane>
        );
    }

    const text = content || '';
    const usePlain = text.length > HIGHLIGHT_MAX;

    return (
        <DevEditorPane>
            <div className="dev-preview">
                {usePlain ? (
                    <pre className="dev-preview-plain">{text}</pre>
                ) : (
                    <SyntaxHighlighter
                        language={language === 'plaintext' ? 'text' : (language || 'text')}
                        style={oneDark}
                        customStyle={{
                            margin: 0, padding: '12px 14px', fontSize: 12, lineHeight: 1.6,
                            background: 'transparent', minHeight: '100%',
                        }}
                        showLineNumbers={text.length < 8000}
                        wrapLongLines
                    >
                        {text}
                    </SyntaxHighlighter>
                )}
            </div>
        </DevEditorPane>
    );
}

export default memo(DevFilePreview);
